import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useApplicationReview } from '../../../contexts/ApplicationReviewContext';
import { reviewWorkflow, roleDuties } from '../../../data/applicationReview';
import { toBn } from '../../../utils/bn';
export function ReviewWorkflowStrip() {
  const {
    role
  } = useApplicationReview();
  return <section aria-label="মেকার-চেকার অনুমোদন প্রক্রিয়া" className="mb-5 rounded-lg border border-border bg-white p-3 shadow-sm" data-id="element-548" data-mp="b2n3qa82hsgt">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2 px-1" data-id="element-549" data-mp="jw9u1ktia3im">
        <p className="text-xs font-semibold text-navy-900" data-id="element-550" data-mp="jym99q7vpzrz">ভূমিকাভিত্তিক অনুমোদন প্রক্রিয়া (মেকার-চেকার)</p>
        <p className="text-[11px] text-slate-500" data-id="element-551" data-mp="tufurz3kt3lw">আপনার অনুমতি: {roleDuties[role]}</p>
      </div>
      <ol className="flex flex-wrap items-stretch gap-1.5 lg:flex-nowrap" data-id="element-552" data-mp="30kvt1bc5vta3">
        {reviewWorkflow.map((s, i) => {
        const on = s.role === role;
        return <li key={`${s.role}-${i}`} className="flex flex-1 items-center gap-1.5" data-id="element-553" data-mp="2vnnc1e2r1vaf" data-mpi={i}>
              <div className={`flex-1 rounded-md border px-2.5 py-2 ${on ? 'border-navy-800 bg-navy-800 text-white' : 'border-slate-200 bg-slate-50 text-navy-900'}`} data-id="element-554" data-mp="g13zt2yl4fx9">
                <p className={`text-[10px] font-semibold ${on ? 'text-navy-200' : 'text-slate-400'}`} data-id="element-555" data-mp="ozz2i52f77vt">ধাপ {toBn(i + 1)}</p>
                <p className="text-[12.5px] font-semibold leading-tight" data-id="element-556" data-mp="trpfyjwnmbrg">{s.role}</p>
                <p className={`text-[10.5px] leading-tight ${on ? 'text-navy-100' : 'text-slate-500'}`} data-id="element-557" data-mp="yoz661rvargc">{s.task}</p>
              </div>
              {i < reviewWorkflow.length - 1 && <ChevronRight className="hidden h-4 w-4 shrink-0 text-slate-300 lg:block" aria-hidden data-id="element-558" data-mp="17qyocxemc1kv" />}
            </li>;
      })}
      </ol>
    </section>;
}